import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "./LandingPage.css";
import { selectUser } from "../../features/userSlice";

const LandingPage = () => {
  const user = useSelector(selectUser);
  const token = user?.token;
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate("/dashboard");
    }
  }, [token, navigate]);

  return (
    <div className="landing-page-root">
      <div className="landing-content">
        <h1 className="title">Welcome to Singhal Group of Industries</h1>
        <p className="subtitle">Committed to providing high-quality products</p>

        {!token && (
          <div className="buttonContainer">
            <a href="/login">
              <button className="landingbutton">Login</button>
            </a>
          </div>
        )}
      </div>
      <footer className="landing-footer">
        © 2025 CLMS — All rights reserved.
      </footer>
    </div>
  );
};

export default LandingPage;
